'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { icons } from '@peerless/ui-assets/icons';
import { RouterLink } from '@/navigation';

export function AccountButton() {
  return (
    <Button variant={'outlined'} color={'secondary'} component={RouterLink} href="/account">
      <FontAwesomeIcon icon={icons.user} />
    </Button>
  );
}
